/* i18n dictionary for Flexworx Ops field-facing screens.
   Admin/PM-only screens can stay English. */

const DICT = {
    // Common
    "loading": { en: "Loading…", hi: "लोड हो रहा है…", bn: "লোড হচ্ছে…" },
    "cancel": { en: "Cancel", hi: "रद्द करें", bn: "বাতিল" },
    "save": { en: "Save", hi: "सहेजें", bn: "সেভ করুন" },
    "close": { en: "Close", hi: "बंद करें", bn: "বন্ধ করুন" },
    "done": { en: "Done", hi: "पूरा हुआ", bn: "সম্পন্ন" },
    "submit": { en: "Submit", hi: "जमा करें", bn: "জমা দিন" },
    "yes": { en: "Yes", hi: "हाँ", bn: "হ্যাঁ" },
    "no": { en: "No", hi: "नहीं", bn: "না" },
    "note": { en: "Note", hi: "टिप्पणी", bn: "নোট" },
    "photo": { en: "Photo", hi: "फ़ोटो", bn: "ছবি" },
    "add_photo": { en: "Add photo", hi: "फ़ोटो जोड़ें", bn: "ছবি যোগ করুন" },
    "search": { en: "Search", hi: "खोजें", bn: "অনুসন্ধান করুন" },
    "language": { en: "Language", hi: "भाषा", bn: "ভাষা" },

    // Navigation
    "nav_sites": { en: "Sites", hi: "साइटें", bn: "সাইটসমূহ" },
    "nav_escalations": { en: "Escalations", hi: "एस्केलेशन", bn: "এস্কেলেশন" },
    "nav_sla_lookup": { en: "SLA Lookup", hi: "SLA देखें", bn: "SLA দেখুন" },
    "nav_compliance": { en: "Compliance", hi: "अनुपालन", bn: "কমপ্লায়েন্স" },
    "nav_documents": { en: "Documents", hi: "दस्तावेज़", bn: "ডকুমেন্টস" },
    "nav_messages": { en: "Messages", hi: "संदेश", bn: "বার্তা" },
    "nav_dashboard": { en: "Dashboard", hi: "डैशबोर्ड", bn: "ড্যাশবোর্ড" },
    "nav_training": { en: "Training", hi: "प्रशिक्षण", bn: "প্রশিক্ষণ" },
    "nav_coaching": { en: "Coaching", hi: "कोचिंग", bn: "কোচিং" },
    "back": { en: "Back", hi: "पीछे", bn: "ফিরুন" },
    "next": { en: "Next", hi: "अगला", bn: "পরবর্তী" },
    // Training
    "training_title": { en: "Training library", hi: "प्रशिक्षण पुस्तकालय", bn: "প্রশিক্ষণ লাইব্রেরি" },
    "training_subtitle": { en: "Short courses with quizzes — track completions per staff.", hi: "छोटे कोर्स और क्विज़ — प्रत्येक कर्मचारी की पूर्णता ट्रैक करें।", bn: "ছোট কোর্স ও কুইজ — প্রতিটি স্টাফের সম্পূর্ণতা ট্র্যাক করুন।" },
    "training_new_course": { en: "New course", hi: "नया कोर्स", bn: "নতুন কোর্স" },
    "training_take": { en: "Take", hi: "शुरू करें", bn: "শুরু" },
    "training_start": { en: "Ready to start", hi: "शुरू करने के लिए तैयार", bn: "শুরুর জন্য প্রস্তুত" },
    "training_lang": { en: "Language", hi: "भाषा", bn: "ভাষা" },
    "training_site": { en: "Site", hi: "साइट", bn: "সাইট" },
    "training_pick_staff": { en: "Pick the staff member you are training (hand over the phone).", hi: "जिस कर्मचारी को प्रशिक्षण देना है, उसे चुनें (फ़ोन उन्हें दें)।", bn: "যে স্টাফকে প্রশিক্ষণ দিচ্ছেন তাকে বাছুন (ফোন হাতে দিন)।" },
    "training_or_self": { en: "Or take yourself — recorded against your account.", hi: "या स्वयं करें — आपके खाते में दर्ज होगा।", bn: "অথবা নিজে নিন — আপনার অ্যাকাউন্টে রেকর্ড হবে।" },
    "training_self_take": { en: "Take myself", hi: "स्वयं करें", bn: "আমি নিজে নিই" },
    "training_slide": { en: "Slide", hi: "स्लाइड", bn: "স্লাইড" },
    "training_start_quiz": { en: "Start quiz", hi: "क्विज़ शुरू करें", bn: "কুইজ শুরু করুন" },
    "training_question": { en: "Question", hi: "प्रश्न", bn: "প্রশ্ন" },
    "training_submit_quiz": { en: "Submit quiz", hi: "क्विज़ जमा करें", bn: "কুইজ জমা দিন" },
    "training_answer_all": { en: "Please answer all questions.", hi: "कृपया सभी प्रश्नों का उत्तर दें।", bn: "সব প্রশ্নের উত্তর দিন।" },
    "training_congrats": { en: "Congratulations — passed!", hi: "बधाई हो — उत्तीर्ण!", bn: "অভিনন্দন — পাশ!" },
    "training_try_again": { en: "Not passed — try again", hi: "उत्तीर्ण नहीं — फिर से प्रयास करें", bn: "পাশ হয়নি — আবার চেষ্টা করুন" },
    "training_another": { en: "Another attempt", hi: "एक और प्रयास", bn: "আরেকবার চেষ্টা" },
    "training_all_courses": { en: "All courses", hi: "सभी कोर्स", bn: "সব কোর্স" },
    // Diary
    "diary_title": { en: "Diary", hi: "डायरी", bn: "ডায়েরি" },
    "diary_new_job": { en: "New job", hi: "नया काम", bn: "নতুন কাজ" },
    "diary_close": { en: "Close diary", hi: "डायरी बंद करें", bn: "ডায়েরি বন্ধ করুন" },
    "diary_locked": { en: "Locked", hi: "लॉक हुई", bn: "লক" },
    "diary_context": { en: "Today's context", hi: "आज का संदर्भ", bn: "আজকের প্রসঙ্গ" },
    "diary_absences": { en: "Absences", hi: "अनुपस्थितियाँ", bn: "অনুপস্থিতি" },
    "diary_coaching_due": { en: "Coaching due today", hi: "आज बकाया कोचिंग", bn: "আজকের কোচিং" },
    "diary_compliance_today": { en: "Compliance visits", hi: "अनुपालन विज़िट", bn: "কমপ্লায়েন্স ভিজিট" },
    "diary_jobs": { en: "Jobs", hi: "काम", bn: "কাজ" },
    "diary_all_view": { en: "Supervisor view", hi: "सुपरवाइज़र दृश्य", bn: "সুপারভাইজার ভিউ" },
    "diary_view_as": { en: "Staff view: {name}", hi: "स्टाफ़ दृश्य: {name}", bn: "স্টাফ ভিউ: {name}" },

    "profile_language": { en: "My language", hi: "मेरी भाषा", bn: "আমার ভাষা" },

    // Checklist run screen
    "run_title": { en: "Today's checklist", hi: "आज की चेकलिस्ट", bn: "আজকের চেকলিস্ট" },
    "run_focus_theme": { en: "Focus theme", hi: "आज का विषय", bn: "আজকের বিষয়" },
    "run_day": { en: "Day", hi: "दिन", bn: "দিন" },
    "run_progress_tasks": { en: "Tasks", hi: "कार्य", bn: "কাজ" },
    "run_progress_critical": { en: "Critical", hi: "अत्यावश्यक", bn: "গুরুতর" },
    "run_progress_escalations": { en: "Escalations", hi: "एस्केलेशन", bn: "এস্কেলেশন" },
    "run_priority_critical": { en: "CRITICAL", hi: "अत्यावश्यक", bn: "গুরুতর" },
    "run_priority_standard": { en: "STANDARD", hi: "सामान्य", bn: "সাধারণ" },
    "run_status_pending": { en: "Pending", hi: "बाकी है", bn: "অপেক্ষমাণ" },
    "run_status_done": { en: "Done", hi: "पूरा हुआ", bn: "সম্পন্ন" },
    "run_status_in_progress": { en: "In progress", hi: "जारी है", bn: "চলছে" },
    "run_status_escalated": { en: "Escalated", hi: "एस्केलेटेड", bn: "এস্কেলেটেড" },
    "run_status_na": { en: "N/A", hi: "लागू नहीं", bn: "প্রযোজ্য নয়" },
    "run_escalation_note_required": { en: "A note is required for escalations", hi: "एस्केलेशन के लिए टिप्पणी अनिवार्य है", bn: "এস্কেলেশনের জন্য নোট আবশ্যক" },
    "run_escalation_note_placeholder": { en: "Describe what happened and next step…", hi: "क्या हुआ और अगला कदम बताएं…", bn: "কী ঘটেছে ও পরবর্তী পদক্ষেপ লিখুন…" },
    "run_signoff": { en: "Sign off", hi: "साइन-ऑफ़ करें", bn: "সাইন অফ" },
    "run_signoff_confirm": { en: "Confirm sign-off", hi: "साइन-ऑफ़ की पुष्टि करें", bn: "সাইন-অফ নিশ্চিত করুন" },
    "run_signoff_locked": { en: "Signed off — this run is locked.", hi: "साइन-ऑफ़ हो चुका है — यह लॉक है।", bn: "সাইন-অফ সম্পন্ন — এটি লক করা।" },
    "run_signoff_critical_warning": { en: "Some CRITICAL tasks are not marked DONE or N/A. Please state the reason:", hi: "कुछ अत्यावश्यक कार्य पूरा या लागू-नहीं नहीं हैं। कृपया कारण बताएं:", bn: "কিছু গুরুতর কাজ সম্পন্ন বা প্রযোজ্য-নয় হিসেবে চিহ্নিত নয়। কারণ লিখুন:" },
    "run_share_wa": { en: "Share on WhatsApp", hi: "व्हाट्सएप पर भेजें", bn: "হোয়াটসঅ্যাপে শেয়ার" },

    // Attendance
    "att_present": { en: "Present", hi: "उपस्थित", bn: "উপস্থিত" },
    "att_absent": { en: "Absent", hi: "अनुपस्थित", bn: "অনুপস্থিত" },
    "att_cover_arranged": { en: "Cover arranged?", hi: "कवर की व्यवस्था?", bn: "কভার ব্যবস্থা করা হয়েছে?" },
    "att_check_in": { en: "Check in", hi: "चेक-इन", bn: "চেক ইন" },
    "att_check_out": { en: "Check out", hi: "चेक-आउट", bn: "চেক আউট" },
    "att_today": { en: "Today's attendance", hi: "आज की उपस्थिति", bn: "আজকের হাজিরা" },
    "att_title": { en: "Attendance", hi: "उपस्थिति", bn: "হাজিরা" },
    "att_back_to_run": { en: "Back to checklist", hi: "चेकलिस्ट पर वापस जाएं", bn: "চেকলিস্টে ফিরুন" },
    "att_roster": { en: "Roster", hi: "स्टाफ़ सूची", bn: "স্টাফ তালিকা" },
    "att_monthly": { en: "Monthly sheet", hi: "मासिक शीट", bn: "মাসিক শীট" },
    "att_no_roster": { en: "No active roster.", hi: "कोई सक्रिय स्टाफ़ सूची नहीं है।", bn: "কোনো সক্রিয় স্টাফ তালিকা নেই।" },
    "att_add_staff": { en: "Add staff", hi: "स्टाफ़ जोड़ें", bn: "স্টাফ যোগ করুন" },
    "att_required": { en: "Required", hi: "अनिवार्य", bn: "আবশ্যক" },
    "att_present_time": { en: "Present · in {in}{outPart}", hi: "उपस्थित · आगमन {in}{outPart}", bn: "উপস্থিত · প্রবেশ {in}{outPart}" },
    "att_out_suffix": { en: " · out {out}", hi: " · प्रस्थान {out}", bn: " · প্রস্থান {out}" },
    "att_absent_line_cover": { en: "Absent · {reason} · Cover: {cover}", hi: "अनुपस्थित · {reason} · कवर: {cover}", bn: "অনুপস্থিত · {reason} · কভার: {cover}" },
    "att_absent_line_no_cover": { en: "Absent · {reason} · No cover", hi: "अनुपस्थित · {reason} · कोई कवर नहीं", bn: "অনুপস্থিত · {reason} · কোনো কভার নেই" },
    "att_role_receptionist": { en: "Receptionist", hi: "रिसेप्शनिस्ट", bn: "রিসেপশনিস্ট" },
    "att_role_housekeeper": { en: "Housekeeper", hi: "हाउसकीपर", bn: "হাউসকিপার" },
    "att_role_security": { en: "Security Guard", hi: "सुरक्षा गार्ड", bn: "সিকিউরিটি গার্ড" },
    "att_role_other": { en: "Other", hi: "अन्य", bn: "অন্যান্য" },
    "att_mark_absent": { en: "Mark absent", hi: "अनुपस्थित के रूप में चिह्नित करें", bn: "অনুপস্থিত হিসেবে চিহ্নিত করুন" },
    "att_reason_required": { en: "Reason (required)", hi: "कारण (अनिवार्य)", bn: "কারণ (আবশ্যক)" },
    "att_cover_name_required": { en: "Cover person name (required)", hi: "कवर व्यक्ति का नाम (अनिवार्य)", bn: "কভার ব্যক্তির নাম (আবশ্যক)" },
    "att_contractual_fields": { en: "Contractual fields", hi: "अनुबंधित फ़ील्ड", bn: "চুক্তিভিত্তিক ক্ষেত্র" },
    "att_contract_role_note": { en: "This role is contract-required. Client-inform & replacement times are mandatory below.", hi: "यह भूमिका अनुबंध के तहत अनिवार्य है। नीचे क्लाइंट-सूचना और प्रतिस्थापन समय भरना ज़रूरी है।", bn: "এই ভূমিকাটি চুক্তিতে বাধ্যতামূলক। নিচে ক্লায়েন্ট-অবহিতকরণ ও প্রতিস্থাপন সময় দিতে হবে।" },
    "att_client_informed_at": { en: "Client contact informed at (deadline {t})", hi: "क्लाइंट संपर्क को सूचित किया (अंतिम समय {t})", bn: "ক্লায়েন্টকে জানানোর সময় (শেষ সময় {t})" },
    "att_replacement_at": { en: "Replacement deployed at (max {h}h from deadline)", hi: "प्रतिस्थापन तैनात किया (अंतिम समय से अधिकतम {h} घंटे)", bn: "প্রতিস্থাপন মোতায়েন করা হয়েছে (শেষ সময় থেকে সর্বাধিক {h} ঘণ্টা)" },
    "att_yes": { en: "Yes", hi: "हाँ", bn: "হ্যাঁ" },
    "att_no": { en: "No", hi: "नहीं", bn: "না" },
    "att_record_absence": { en: "Record absence", hi: "अनुपस्थिति दर्ज करें", bn: "অনুপস্থিতি রেকর্ড করুন" },
    "att_toast_checked_in": { en: "Checked in", hi: "चेक-इन हो गया", bn: "চেক-ইন হয়েছে" },
    "att_toast_checked_out": { en: "Checked out", hi: "चेक-आउट हो गया", bn: "চেক-আউট হয়েছে" },
    "att_toast_absence_recorded": { en: "Absence recorded", hi: "अनुपस्थिति दर्ज हो गई", bn: "অনুপস্থিতি রেকর্ড হয়েছে" },
    "att_toast_violation": { en: "Contract violation: {msg} — PM alerted", hi: "अनुबंध उल्लंघन: {msg} — PM को सूचित किया गया", bn: "চুক্তি লঙ্ঘন: {msg} — PM-কে জানানো হয়েছে" },
    "att_violation_client_late": { en: "Client informed at {at} — after {deadline} deadline", hi: "क्लाइंट को {at} पर सूचित किया — {deadline} की अंतिम समय-सीमा के बाद", bn: "ক্লায়েন্টকে {at}-এ জানানো — {deadline} সময়সীমার পরে" },
    "att_violation_replacement_late": { en: "Replacement deployed at {at} — exceeds {h}h from deadline", hi: "प्रतिस्थापन {at} पर तैनात — अंतिम समय से {h} घंटे से अधिक", bn: "প্রতিস্থাপন {at}-এ মোতায়েন — সময়সীমা থেকে {h} ঘণ্টার বেশি" },

    // Documents (staff view)
    "docs_title": { en: "Documents", hi: "दस्तावेज़", bn: "ডকুমেন্টস" },
    "docs_all": { en: "All", hi: "सभी", bn: "সব" },
    "docs_cat_floor_plans": { en: "Floor plans", hi: "फ़्लोर प्लान", bn: "ফ্লোর প্ল্যান" },
    "docs_cat_compliance": { en: "Compliance", hi: "अनुपालन", bn: "কমপ্লায়েন্স" },
    "docs_cat_sops": { en: "SOPs", hi: "SOP", bn: "SOP" },
    "docs_cat_staff": { en: "Staff", hi: "स्टाफ़", bn: "স্টাফ" },
    "docs_expiry": { en: "Expires", hi: "समाप्ति तिथि", bn: "মেয়াদ শেষ" },
    "docs_upload": { en: "Upload document", hi: "दस्तावेज़ अपलोड करें", bn: "ডকুমেন্ট আপলোড" },
    "docs_open": { en: "Open", hi: "खोलें", bn: "খুলুন" },
    "docs_replace": { en: "Replace with new version", hi: "नए संस्करण से बदलें", bn: "নতুন সংস্করণে বদলান" },

    // Messaging
    "chat_channels": { en: "Channels", hi: "चैनल", bn: "চ্যানেল" },
    "chat_direct": { en: "Direct messages", hi: "सीधे संदेश", bn: "সরাসরি বার্তা" },
    "chat_new_dm": { en: "New DM", hi: "नया DM", bn: "নতুন DM" },
    "chat_placeholder": { en: "Type a message…", hi: "संदेश लिखें…", bn: "বার্তা লিখুন…" },
    "chat_send": { en: "Send", hi: "भेजें", bn: "পাঠান" },
    "chat_pick_preset": { en: "Pick a preset", hi: "प्रीसेट चुनें", bn: "প্রিসেট বাছুন" },
    "chat_preset_params": { en: "Fill the details", hi: "विवरण भरें", bn: "বিস্তারিত পূরণ করুন" },
    "chat_unread": { en: "unread", hi: "अपठित", bn: "অপঠিত" },
    "chat_no_messages": { en: "No messages yet.", hi: "अभी कोई संदेश नहीं है।", bn: "এখনও কোনো বার্তা নেই।" },
};

export function t(user, key, params) {
    const lang = (user && user.language) || "en";
    const entry = DICT[key];
    if (!entry) return key;
    let s = entry[lang] || entry.en || key;
    if (params) {
        Object.entries(params).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, String(v)); });
    }
    return s;
}

export function taskText(task, lang) {
    if (lang === "hi" && task.text_hi) return task.text_hi;
    if (lang === "bn" && task.text_bn) return task.text_bn;
    return task.text;
}

export const AVAILABLE_LANGUAGES = [
    { code: "en", label: "English" },
    { code: "hi", label: "हिन्दी" },
    { code: "bn", label: "বাংলা" },
];
